import { useState, useEffect } from "react";
import { apiSend, getRoute } from "@services/axios";
import { message } from "antd";
import { Label } from "rc-easyui";

export const useSignUpConf = (selectedCountryFromParent) => {
  const [currencies, setCurrencies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  // const [selectedCountry, setSelectedCountry] = useState("");
  const [loading, setLoading] = useState(true);
  // Load currencies
  useEffect(() => {
    const loadCurrencies = async () => {
      try {
        const response = await apiSend(getRoute("currencies"), "get", []);
        const formatted = response.data.result.map((currency) => ({
          id: currency.id,
          code: currency.code,
          value: currency.code,
          name: currency.name,
          Label: currency.name
        }));
        setCurrencies(formatted);
      } catch (error) {
        console.error("Currency error:", error);
        message.error("Unable to load currencies.");
      }
    };

    loadCurrencies();
  }, []);

  // Load countries
  useEffect(() => {
    const loadCountries = async () => {
      try {
        const response = await apiSend(getRoute("countries") + '/all', "get", []);

        const formatted = response.data.result.map((country) => ({
          // console.log('Country data:', countryData);
          id: country.id,
          code: country.code,
          dial_code: country.dial_code,
          label: country.name,
          name: country.name,
          value: country.code
        }));
        setCountries(formatted);
      } catch (error) {
        console.error("Country error:", error);
        message.error("Unable to load countries.");
      } finally {
        setLoading(false);
      }
    };
    loadCountries();
  }, []);

  // Load cities when country changes
 useEffect(() => {
    if (!selectedCountryFromParent) {
      setCities([]);
      return;
    }

    const loadCities = async () => {
      try {
        const response = await apiSend(
          [getRoute("cities"), selectedCountryFromParent, 'all'].join("/"),
          "get",
          []
        );
        const formatted = response.data.result.map((city) => ({
          id: city.id,
          name: city.name,
          value: city.name,
          label: city.name
        }));
        setCities(formatted);
      } catch (error) {
        console.error("City error:", error);
        message.error("Unable to load cities.");
      }
    };

    loadCities();
  }, [selectedCountryFromParent]);

  return {
    currencies,
    countries,
    cities,

    loading,
  };
};
